import { RequestService } from "../../../../common/services/RequestService";
import { ADD_PERSON_TO_LIST } from "./constants";
import {adjustDataToFetch} from "./adjustData";

export const addPersonToListRequest = async (orderId, payload) => {
  const response = await RequestService.post(
    ADD_PERSON_TO_LIST.replace("{order_id}", orderId),
    adjustDataToFetch(payload)
  );

  return response
};
